var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0Zm-3 22v19l12-9.5L29 22Z","fill":"currentColor"}));
}

PlayInline.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
